/** Supplier disclosure with a one-use confirmation for the native product form. */
class SourcedOrderInfo extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-source-info-open]');
    this.confirm = this.querySelector('[data-source-info-confirm]');
    this.selection = this.querySelector('[data-source-info-selection]');
    if (!this.dialog || !this.trigger) return;
    this.trigger.hidden = false;
    this.trigger.addEventListener('click', () => {
      this.openInfo(this.trigger);
    }, { signal });
    this.confirm?.addEventListener('click', () => {
      if (!this.dialog.open || !this.purchase) return;
      const confirm = this.purchase;
      this.purchase = null;
      this.confirm.disabled = true;
      this.dialog.close();
      confirm();
    }, { signal });
    this.querySelector('[data-source-info-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const r = this.dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      this.purchase = null;
      window.theme?.unlockScroll?.('sourced-order-info');
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }, { signal });
  }

  openInfo(opener, selection = '', purchase = null) {
    if (!this.dialog?.showModal || this.dialog.open) return;
    this.opener = opener;
    this.purchase = purchase;
    if (this.confirm) { this.confirm.hidden = !purchase; this.confirm.disabled = false; }
    if (this.selection) { this.selection.textContent = selection; this.selection.hidden = !selection; }
    this.querySelector('[data-source-delivery-estimate]')?.render?.();
    this.dialog.showModal();
    const body = this.querySelector('.source-info__body');
    if (body) body.scrollTop = 0;
    window.theme?.lockScroll?.('sourced-order-info');
  }

  cancelPurchase() {
    if (!this.purchase) return;
    this.purchase = null;
    if (this.dialog?.open) this.dialog.close();
  }

  disconnectedCallback() {
    this.purchase = null;
    if (this.dialog?.open) {
      this.dialog.close();
      window.theme?.unlockScroll?.('sourced-order-info');
    }
    this.controller?.abort();
  }
}
if (!customElements.get('sourced-order-info')) customElements.define('sourced-order-info', SourcedOrderInfo);
